// extracted by mini-css-extract-plugin
export default {"newsfeed":"BL-z"};